<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="CAE"
          label-for="cae"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="cae"
            v-model.trim="$v.cae.$model" 
            :state="caeValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="caeFeedback">
            {{ caeInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Fecha Venc."
          label-for="fechaVencimientoCAE"
          :label-cols="labelCols"
          description="Fecha de vencimiento del CAE"
          horizontal>
          <b-form-input 
            id="fechaVencimientoCAE" 
            v-model="$v.fechaVencimientoCAE.$model" 
            :state="fechaVencimientoCAEValida"
            type="date">
          </b-form-input>
          <b-form-invalid-feedback id="fechaVencimientoCAEFeedback">
            {{ fechaVencimientoCAEInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import { required, numeric, maxLength, minLength, minValue } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import moment from 'moment';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'VentasActualizacionCAE',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    ventaId: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      cae: '',
      fechaVencimientoCAE: moment.utc(new Date()).format('YYYY-MM-DD'),

      noValidar: true,
      caeValido: null,
      caeInvalidoMsj: '',
      fechaVencimientoCAEValida: null,
      fechaVencimientoCAEInvalidaMsj: '',

      labelCols: 2,
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'cae' || validarTodos) {
        if (this.$v.cae.$error) {
          this.caeValido = false;
          if (!this.$v.cae.required) {
            this.caeInvalidoMsj = 'Debe ingresar el código de autorización electrónica';
          } else if (!this.$v.cae.numeric) {
            this.caeInvalidoMsj = 'El código de autorización electrónica ingresado no es válido';
          } else if (!this.$v.cae.maxLength || !this.$v.cae.minLength) {
            this.caeInvalidoMsj = 'La longitud del código de autorización electrónica no es válida';
          }      
        } else {
          this.caeValido = null;
          this.caeInvalidoMsj = '';
        }
      }

      // if (campo == 'fechaVencimientoCAE' || validarTodos) {
      //   if (this.$v.fechaVencimientoCAE.$error) {
      //     this.fechaVencimientoCAEValida = false;
      //     if (!this.$v.fechaVencimientoCAE.minValue) {
      //       this.fechaVencimientoCAEInvalidaMsj = 'La fecha de vencimiento ingresada no es válida';
      //     }      
      //   } else {
      //     this.fechaVencimientoCAEValida = null;
      //     this.fechaVencimientoCAEInvalidaMsj = '';
      //   }
      // }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let save = Boolean(true);

      this.$v.$touch();

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            ventaId: this.ventaId,
            cae: this.cae.trim(),
            fechaVencimientoCAE: this.fechaVencimientoCAE
          }
          this.showSpinner();
          this.$store.dispatch('ventas/actualizarCAE', params)
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.close, this.close, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    close() {
      this.$emit('closeActualizacion', true);
    },
    cancelar() {
      this.$emit('closeActualizacion', false);
    },
  },
  validations: {
    cae: {
      required,
      numeric,
      minLength: minLength(14),
      maxLength: maxLength(14)
    },
    fechaVencimientoCAE: {}
    // fechaVencimientoCAE: {
    //   minValue(val) {
    //     return new Date(val) > new Date();
    //   }
    // }
  },  
  watch: {
  }    
}
</script>

<style>
</style>
